import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import authReducer from "@/store/slices/auth";
import tenantReducer from "@/store/slices/tenant";
import reportsReducer from "@/store/slices/reports";
import exceptionsReducer from "@/store/slices/exceptions";
import syncReducer from "@/store/slices/sync";
import dashboardReducer from "@/store/slices/dashboard";
import mappingRulesReducer from "@/store/slices/mappingRules";
import corporateAccountsReducer from "@/store/slices/corporateAccounts";
import otaChannelsReducer from "@/store/slices/otaChannels";
import usersReducer from "@/store/slices/users";
import themeReducer from "@/store/slices/theme";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    tenant: tenantReducer,
    dashboard: dashboardReducer,
    reports: reportsReducer,
    exceptions: exceptionsReducer,
    sync: syncReducer,
    mappingRules: mappingRulesReducer,
    corporateAccounts: corporateAccountsReducer,
    otaChannels: otaChannelsReducer,
    users: usersReducer,
    theme: themeReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
